<div class="main" [dir]="translate.currentLang == 'en'? 'ltr' : 'rtl'">
  <!-- <app-landing-page></app-landing-page> -->
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
